import React, { type PropsWithChildren } from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	resultsListGridArea: {
		gridArea: 'results-list',
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.300'),
	},
	noMoreResults: {
		marginBottom: token('space.400'),
	},
});

type SearchResultsListProps = {
	containsSearchResults: boolean;
};

export const SearchResultsList = ({
	children,
	containsSearchResults,
}: PropsWithChildren<SearchResultsListProps>): React.JSX.Element => {
	return (
		<Box
			xcss={cx(styles.resultsListGridArea, styles.noMoreResults)}
			testId="search-page-results-list"
			{...(containsSearchResults && { role: 'list' })}
		>
			{children}
		</Box>
	);
};
